module.exports = __webpack_public_path__ + "img/toolPic8.30937b91.png";